var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconColapse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9896 33C26.0255 33 33.5 25.5256 33.5 16.5104C33.5 7.47445 26.0047 0 16.9896 0C7.95362 0 0.5 7.47445 0.5 16.5104C0.5 25.5256 7.97443 33 16.9896 33ZM16.9896 30.564C9.20284 30.564 2.9568 24.2971 2.9568 16.5104C2.9568 8.70285 9.18203 2.43596 16.9896 2.43596C24.7763 2.43596 31.0432 8.70285 31.064 16.5104C31.064 24.2971 24.7972 30.564 16.9896 30.564ZM14.0539 22.5691L22.9025 17.3224C23.5271 16.9476 23.5063 16.0732 22.9025 15.7193L14.0539 10.4517C13.4085 10.0562 12.5965 10.3684 12.5965 11.0555V21.9445C12.5965 22.6524 13.3669 22.9647 14.0539 22.5691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconColapse);
export default __webpack_public_path__ + "static/media/sidebar-icon-colapse.0a59ef44c673a2ca3ec19d486d93ca8e.svg";
export { ForwardRef as ReactComponent };